
import { useState, useEffect, useRef } from 'react'
import { Button, FormControl } from '@mui/material'
import { jaJP } from '@mui/x-data-grid'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import CloseIcon from '@mui/icons-material/Close'
import { addDays, format } from 'date-fns'
import { useAuth } from './../../contexts/AuthContext'
import { usePost } from './../../apis/ApiRequests'
import { CustomDataGrid } from '../../components/dataGrid/CustomDataGrid'
import ReaOnlyOutlinedInput from '../../components/input/ReaOnlyOutlinedInput'
import Header from '../../components/Header'
import Frame from '../../components/uiParts/Frame'
import TitleBar from '../../components/uiParts/TitleBar'
import NumPad from '../../components/uiParts/NumPad'
import CustomConfirm from '../../components/confirm/CustomConfirm'
import BidSearchForm from '../../components/uiParts/bid/BidSearchForm'
import BidMastaInputForm from '../../components/uiParts/bid/BidMastaInputForm'
import { dateToString, stringToDate } from '../../utils/Library'
import CustomSnackBar from '../../components/alert/CustomSnackBar'
import { fishStyleList, kgDivision } from '../../Store'
import CustomSelect from '../../components/select/CustomSelect'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CustomCheckbox from '../../components/input/CustomCheckbox'
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp'
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import UpdateIcon from '@mui/icons-material/Update'

const UnloadList = () => {

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - 基本情報を設定
	//-----------------------------------------------
    const { authInfo }   = useAuth()
    const facilityCode   = authInfo.facilityCode
    const facilityName   = authInfo.facilityName
    const userId         = authInfo.userId
    const luserName      = authInfo.userName
    const authority      = authInfo.authority
    const today          = format(addDays(new Date(), 0), 'yyyy-MM-dd')

	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [ contentsHeight,      setContentsHeight      ] = useState(window.innerHeight -100)
    const [ dataGridHeight,      setDataGridHeight      ] = useState(window.innerHeight -290)
    const [ containerHeight,     setContainerHeight     ] = useState(window.innerHeight -100)
    const [ dataGridWidth,       setDataGridWidth       ] = useState(window.innerWidth -480)
    const [ condition ,          setCondition           ] = useState('')
    const [ searchCount,         setSearchCount         ] = useState(0)
    const [ targetList,          setTargetList          ] = useState('')
    const [ entryDate,           setEntryDate           ] = useState(today)
    const [ unloadList,             setUnloadList             ] = useState([])
	const [ checkedUnloadList,      setCheckedUnloadList      ] = useState([])
    const [ openDialogShipGroup, setOpenDialogShipGroup ] = useState(false)
    const [ openDialogShip,      setOpenDialogShip      ] = useState(false)
    const [ openDialogFishSpec,  setOpenDialogFishSpec  ] = useState(false)
    const [ openConfirm,         setOpenConfirm         ] = useState(false)
    const [ openSnackBarTrue,    setOpenSnackBarTrue    ] = useState(false)
    const [ openSnackBarFalse,   setOpenSnackBarFalse   ] = useState(false)
    const [ openRequire,         setOpenRequire         ] = useState(false)
    const [ requireMessage,      setRequireMessage      ] = useState('')
    const [ entryId,            setEntryId            ] = useState('')
    const [ senmeiGroupCode,     setSenmeiGroupCode     ] = useState('')
    const [ senmeiGroup,         setSenmeiGroup         ] = useState('')
    const [ senmeiCode,          setSenmeiCode          ] = useState('')
    const [ senmei,              setSenmei              ] = useState('')
    const [ gyoshuCode,          setGyoshuCode          ] = useState('')
    const [ gyoshu,              setGyoshu              ] = useState('')
    const [ nisugata,            setNisugata            ] = useState(8)
    const [ kikakuCode,          setKikakuCode          ] = useState('')
    const [ kikaku,              setKikaku              ] = useState('')
    const [ kgKubun,             setKgKubun             ] = useState(1)
    const [ kgSuryo,             setKgSuryo             ] = useState('')
    const [ suryo,               setSuryo               ] = useState(1)
    const [ yokiCode,            setYokiCode            ] = useState('')
    const [ yoki,                setYoki                ] = useState('')
    const [ commentCode,         setCommentCode         ] = useState('')
    const [ comment,             setComment             ] = useState('')
    const [ memoCode,            setMemoCode            ] = useState('')
    const [ memo,                setMemo                ] = useState('')
    const [ bidStatus,           setBidStatus           ] = useState('0')
    const [ shipList,            setShipList            ] = useState([])
    const [ shipGroupList,       setShipGroupList       ] = useState([])
    const [ fishSpecList,        setFishSpecList        ] = useState([])
    const [ standardList,        setStandardList        ] = useState([])
    const [ commentList,         setCommentList         ] = useState([])
    const [ memoList,            setMemoList            ] = useState([])
    const [ senbetsuFlag,        setSenbetsuFlag        ] = useState(false)
    const [ mikomiFlag,          setMikomiFlag          ] = useState(false)
    const [ seqNo,         setSeqNo         ] = useState('')
    const [ openDialogStandard,  setOpenDialogStandard  ] = useState(false)
    const [ focusCell,           setFocusCell           ] = useState('')
    const [ containerList,       setContainerList       ] = useState([])
    const [ openDialogContainer, setOpenDialogContainer ] = useState(false)
    const [ openDialogFishStyle, setOpenDialogFishStyle ] = useState(false)
    
	//-----------------------------------------------
    // initialize - useRef
	//-----------------------------------------------
    const senmeiRef  = useRef()
    const gyoshuRef  = useRef()
    const kikakuRef  = useRef()
    const kgSuryoRef = useRef()
    const yokiRef    = useRef()
    const suryoRef    = useRef()
    
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
    // API - searchData / UnloadList
	//-----------------------------------------------
    const { response : searchData_res, loading : searchData_Loading, post:searchData_post } = usePost()
    const searchData = async () => {
        const numericDate = dateToString(entryDate)
        const postData = {
            'className'    : 'mch.models.table.UnloadList',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'keyword1'     : numericDate,
            'keyword2'     : condition
        }
        await searchData_post(postData)
    }
	//-----------------------------------------------
    // API - getNextId / UnloadList
	//-----------------------------------------------
    const { response : getNextId_res, post : getNextId_post } = usePost()
    const getNextId = async () => {
        const postData = {
            'className'    : 'mch.models.table.UnloadList',
            'methodName'   : 'getNextId',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getNextId_post(postData)
    }
	//-----------------------------------------------
    // API - getNextId / UnloadList
	//-----------------------------------------------
    const { response : getNextNo_res, post : getNextNo_post } = usePost()
    const getNextNo = async () => {
        const postData = {
            'className'    : 'mch.models.table.UnloadList',
            'methodName'   : 'getNextNo',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getNextNo_post(postData)
    }
	//-----------------------------------------------
    // API - setData / UnloadList
	//-----------------------------------------------
    const { response : setData_res, post:setData_post } = usePost()
    const setData = async (targetEntryId, activeFlag) => {
        const numericDate = dateToString(entryDate)
        const postData = {
            'className'       : 'mch.models.table.UnloadList',
            'methodName'      : 'setData',
            'facilityCode'    : facilityCode,
            'userId'          : userId,
            'activeFlag'      : activeFlag,
            'userId'          : userId,
            'entryId'        : targetEntryId,
            'entryDate'       : numericDate,
            'senmeiGroupCode' : senmeiGroupCode,
            'senmeiGroup'     : senmeiGroup,
            'senmei'          : senmei,
            'senmeiCode'      : senmeiCode,
            'senmei'          : senmei,
            'gyoshuCode'      : gyoshuCode,
            'gyoshu'          : gyoshu,
            'kgKubun'         : kgKubun,
            'nisugata'        : nisugata,
            'kikakuCode'      : kikakuCode,
            'kikaku'          : kikaku,
            'kgSuryo'         : kgSuryo,
            'yokiCode'        : yokiCode,
            'yoki'            : yoki,
            'suryo'           : suryo,
            'commentCode'     : commentCode,
            'comment'         : comment,
            'memoCode'        : memoCode,
            'memo'            : memo,
            'senbetsuFlag'    : senbetsuFlag ? 1 : 0,
            'mikomiFlag'      : mikomiFlag ? 1 : 0,
            'seqNo'           : seqNo,
            'bidStatus'       : bidStatus
        }
        await setData_post(postData)
    }
	//-----------------------------------------------
    // API - setGroupNo / UnloadList
	//-----------------------------------------------
    const { response : setGroupNo_res, post : setGroupNo_post } = usePost()
    const setGroupNo = async (targetEntryId, groupNo, seqNo) => {
        const postData = {
            'className'    : 'mch.models.table.UnloadList',
            'methodName'   : 'setGroupNo',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'entryId'     : targetEntryId,
            'groupNo'        : groupNo,
            'seqNo'        : seqNo,
        }
        await setGroupNo_post(postData)
    }
	//-----------------------------------------------
    // API - updateDisplayNo / UnloadList
	//-----------------------------------------------
    const { response : updateDisplayNo_res, post : updateDisplayNo_post } = usePost()
    const updateDisplayNo = async (targetEntryId, displayNo) => {
        const postData = {
            'className'    : 'mch.models.table.UnloadList',
            'methodName'   : 'updateDisplayNo',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'entryId'     : targetEntryId,
            'displayNo'    : displayNo,
        }
        await updateDisplayNo_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.ShipGroup
	//-----------------------------------------------
    const { response : getDataAll_shipGroup_res, post : getDataAll_shipGroup_post } = usePost()
    const getDataAll_shipGroup = async () => {
        const postData = {
            'className'    : 'mch.models.masta.ShipGroup',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_shipGroup_post(postData)
    }
	//-----------------------------------------------
    // API - getData / masta.Ship
	//-----------------------------------------------
    const { response : getData_shipGroup_res, post : getData_shipGroup_post } = usePost()
    const getData_shipGroup = async () => {
        const postData = {
            'className'    : 'mch.models.masta.ShipGroup',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : senmei
        }
        await getData_shipGroup_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Ship
	//-----------------------------------------------
    const { response : getDataAll_ship_res, post : getDataAll_ship_post } = usePost()
    const getDataAll_ship = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Ship',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_ship_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Ship
	//-----------------------------------------------
    const { response : searchData_ship_res, post : searchData_ship_post } = usePost()
    const searchData_ship = async (senmeiGroupCode) => {
        const postData = {
            'className'    : 'mch.models.masta.Ship',
            'methodName'   : 'searchDataInGroup',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'groupCode'    : senmeiGroupCode
        }
        await searchData_ship_post(postData)
    }
	//-----------------------------------------------
    // API - getData / masta.Ship
	//-----------------------------------------------
    const { response : getData_ship_res, post : getData_ship_post } = usePost()
    const getData_ship = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Ship',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : senmei
        }
        await getData_ship_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.FishSpec
	//-----------------------------------------------
    const { response : getDataAll_fishSpec_res, post : getDataAll_fishSpec_post } = usePost()
    const getDataAll_fishSpec = async () => {
        const postData = {
            'className'    : 'mch.models.masta.FishSpec',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_fishSpec_post(postData)
    }
	//-----------------------------------------------
    // API - getData / masta.FishSpec
	//-----------------------------------------------
    const { response : getData_fishSpec_res, post : getData_fishSpec_post } = usePost()
    const getData_fishSpec = async () => {
        const postData = {
            'className'    : 'mch.models.masta.FishSpec',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : gyoshu
        }
        await getData_fishSpec_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Container
	//-----------------------------------------------
    const { response : getDataAll_container_res, post : getDataAll_container_post } = usePost()
    const getDataAll_container = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Container',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_container_post(postData)
    }
	//-----------------------------------------------
    // API - getData / masta.Container
	//-----------------------------------------------
    const { response : getData_container_res, post : getData_container_post } = usePost()
    const getData_container = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Container',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : yoki
        }
        await getData_container_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Standard
	//-----------------------------------------------
    const { response : getDataAll_standard_res, post : getDataAll_standard_post } = usePost()
    const getDataAll_standard = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Standard',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_standard_post(postData)
    }
	//-----------------------------------------------
    // API - getData / masta.standard
	//-----------------------------------------------
    const { response : getData_standard_res, post : getData_standard_post } = usePost()
    const getData_standard = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Standard',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : kikaku
        }
        await getData_standard_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Comment
	//-----------------------------------------------
    const { response : getDataAll_comment_res, post : getDataAll_comment_post } = usePost()
    const getDataAll_comment = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Comment',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_comment_post(postData)
    }
	//-----------------------------------------------
    // API - getData / masta.Comment
	//-----------------------------------------------
    const { response : getData_comment_res, post : getData_comment_post } = usePost()
    const getData_comment = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Comment',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_comment_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Memo
	//-----------------------------------------------
    const { response : getDataAll_memo_res, post : getDataAll_memo_post } = usePost()
    const getDataAll_memo = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Memo',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_memo_post(postData)
    }
	//-----------------------------------------------
    // API - getData / masta.Memo
	//-----------------------------------------------
    const { response : getData_memo_res, post : getData_memo_post } = usePost()
    const getData_memo = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Memo',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_memo_post(postData)
    }
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        setSearchCount(searchCount+1)

        getDataAll_shipGroup()
        //getDataAll_ship()
        getDataAll_fishSpec()
        getDataAll_container()
        getDataAll_standard()
        getDataAll_comment()
        getDataAll_memo()
        
        senmeiRef.current.focus()
        setFocusCell('senmei')
        
        const handleResize = () => {
            setContentsHeight(window.innerHeight - 100)
            setDataGridHeight(window.innerHeight - 290)
            setContainerHeight(window.innerHeight - 100)
            setDataGridWidth(window.innerWidth - 480)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
        
    },[])
	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        searchData()
    }, [searchCount])
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchData / UnloadList)
	//-----------------------------------------------
    useEffect(() => {
        setUnloadList([])
        if (searchData_res) {
            setUnloadList(searchData_res.Data)
        }
    }, [searchData_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getNextId / UnloadList)
	//-----------------------------------------------
    useEffect(() => {
        if (getNextId_res) {
            setEntryId(getNextId_res.entryId)
            const requireStatus = checkedRequire() // 必須項目をチェックする
            if (requireStatus) {
                setData(getNextId_res.entryId, 1)
            } else {
                handleClickSnackBarRequire()
            }
        }
    }, [getNextId_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getNextId / UnloadList)
	//-----------------------------------------------
    useEffect(() => {
        if (updateDisplayNo_res) {
            handleClickSnackBarTrue()
        }
    }, [updateDisplayNo_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getNextId / UnloadList)
	//-----------------------------------------------
    useEffect(() => {
        if (getNextNo_res) {
            let number = 0
            checkedUnloadList.map(async (checkedUnloadListId) => {
                unloadList.map((item, index) => {
                    let bidData = {}
                    if (item.id == checkedUnloadListId) { 
                        bidData = item
                        ++number
                        setGroupNo(bidData.entryId, getNextNo_res.groupNo, number)
                    }
                })
            })
        }
    }, [getNextNo_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(setData / UnloadList)
	//-----------------------------------------------
    useEffect(() => {
        if (setData_res) {
            setSearchCount(searchCount+1)

            handleCloseConfirm()
            handleClickSnackBarTrue()
                
            // 船名と魚種は記憶して初期化
            setEntryId('')
            setKgSuryo('')
            setKikakuCode('')
            setKikaku('')
            setKgKubun(1)
            setYokiCode('')
            setYoki('')
            setSenbetsuFlag(false)
            setMikomiFlag(false)
            setBidStatus(0)

            // 規格にフォーカス
            kikakuRef.current.focus()
            setFocusCell('kikaku')
        }
    }, [setData_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getNextId / UnloadList)
	//-----------------------------------------------
    useEffect(() => {
        if (setGroupNo_res) {
            setSearchCount(searchCount+1)
            setCheckedUnloadList([])

            handleCloseConfirm()
            handleClickSnackBarTrue()
        }
    }, [setGroupNo_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_ship)
	//-----------------------------------------------
    useEffect(() => {
        setShipList([])
        if (getDataAll_ship_res) {
            setShipList(getDataAll_ship_res.Data)
        }
    }, [getDataAll_ship_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchData / masta_ship)
	//-----------------------------------------------
    useEffect(() => {
        setShipList([])
        if (searchData_ship_res) {
            setShipList(searchData_ship_res.Data)
            handleClick_dialog_ship()
        }
    }, [searchData_ship_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_ship)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_ship_res) {
            setSenmeiCode(getData_ship_res.code)
            setSenmei(getData_ship_res.displayName)
        }
    }, [getData_ship_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_shipGroup)
	//-----------------------------------------------
    useEffect(() => {
        setShipGroupList([])
        if (getDataAll_shipGroup_res) {
            setShipGroupList(getDataAll_shipGroup_res.Data)
        }
    }, [getDataAll_shipGroup_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_fishSpec)
	//-----------------------------------------------
    useEffect(() => {
        setFishSpecList([])
        if (getDataAll_fishSpec_res) {
            setFishSpecList(getDataAll_fishSpec_res.Data)
        }
    }, [getDataAll_fishSpec_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_fishSpec)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_fishSpec_res) {
            setGyoshuCode(getData_fishSpec_res.code)
            setGyoshu(getData_fishSpec_res.displayName)
        }
    }, [getData_fishSpec_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_container)
	//-----------------------------------------------
    useEffect(() => {
        setContainerList([])
        if (getDataAll_container_res) {
            setContainerList(getDataAll_container_res.Data)
        }
    }, [getDataAll_container_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_container)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_container_res) {
            setYokiCode(getData_container_res.code)
            setYoki(getData_container_res.displayName)
        }
    }, [getData_container_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_standard)
	//-----------------------------------------------
    useEffect(() => {
        setStandardList([])
        if (getDataAll_standard_res) {
            setStandardList(getDataAll_standard_res.Data)
        }
    }, [getDataAll_standard_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_Standard)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_standard_res) {
            setKikaku(getData_standard_res.displayName)
        }
    }, [getData_standard_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_Standard)
	//-----------------------------------------------
    useEffect(() => {
        if (openDialogStandard == false && kikaku != '') {
            kgSuryoRef.current.focus()
            setFocusCell('kgSuryo')
        }
    }, [openDialogStandard])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_comment)
	//-----------------------------------------------
    useEffect(() => {
        setCommentList([])
        if (getDataAll_comment_res) {
            setCommentList(getDataAll_comment_res.Data)
        }
    }, [getDataAll_comment_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_comment)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_comment_res) {
            setCommentCode(getData_comment_res.code)
            setComment(getData_comment_res.displayName)
        }
    }, [getData_comment_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_memo)
	//-----------------------------------------------
    useEffect(() => {
        setMemoList([])
        if (getDataAll_memo_res) {
            setMemoList(getDataAll_memo_res.Data)
        }
    }, [getDataAll_memo_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_memo)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_memo_res) {
            setMemoCode(getData_memo_res.code)
            setMemo(getData_memo_res.displayName)
        }
    }, [getData_memo_res])
	//-----------------------------------------------
    // useEffect - dataGirdの選択
	//-----------------------------------------------
    useEffect(() => {
        if (targetList) {
            setEntryId(targetList.entryId)
            setSenmeiGroupCode(targetList.senmeiGroupCode)
            setSenmeiGroup(targetList.senmeiGroup)
            setSenmeiCode(targetList.senmeiCode)
            setSenmei(targetList.senmei)
            setGyoshuCode(targetList.gyoshuCode)
            setGyoshu(targetList.gyoshu)
            setNisugata(targetList.nisugata)
            setKikakuCode(targetList.kikakuCode)
            setKikaku(targetList.kikaku)
            setKgKubun(targetList.kgKubun)
            setKgSuryo(targetList.kgSuryo)
            setYokiCode(targetList.yokiCode)
            setYoki(targetList.yoki)
            setEntryDate(stringToDate(targetList.entryDate))
            setCommentCode(targetList.commentCode)
            setComment(targetList.comment)
            setMemoCode(targetList.memoCode)
            setMemo(targetList.memo)
            setSenbetsuFlag(targetList.senbetsuFlag ? true : false)
            setMikomiFlag(targetList.mikomiFlag ? true : false)
            setSeqNo(targetList.seqNo)
            setBidStatus(targetList.bidStatus)
        }
    }, [targetList])
	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - 検索ボタン
	//-----------------------------------------------
    const handleClick_search = () => {
        setSearchCount(searchCount+1)
    }
	//-----------------------------------------------
    // eventHandler - 検索クリアボタン
	//-----------------------------------------------
    const handleClick_search_clear = () => {
        setEntryDate(today)
        setCondition('')
        setSearchCount(searchCount+1)
    }
	//-----------------------------------------------
    // eventHandler - 荷主にフォーカス
	//-----------------------------------------------
    const handleClick_senmei = () => {
        setFocusCell('senmei')
    }
	//-----------------------------------------------
    // eventHandler - 魚種にフォーカス
	//-----------------------------------------------
    const handleClick_gyoshu = () => {
        setFocusCell('gyoshu')
    }
	//-----------------------------------------------
    // eventHandler - 企画にフォーカス
	//-----------------------------------------------
    const handleClick_kikaku = () => {
        setFocusCell('kikaku')
    }
	//-----------------------------------------------
    // eventHandler - 容器にフォーカス
	//-----------------------------------------------
    const handleClick_yoki = () => {
        setFocusCell('yoki')
    }
	//-----------------------------------------------
    // eventHandler - 新規ボタン
	//-----------------------------------------------
    const handleClick_new = () => {
        setEntryId('')
        setSenmeiGroupCode('')
        setSenmeiGroup('')
        setSenmeiCode('')
        setSenmei('')
        setGyoshuCode('')
        setGyoshu('')
        setNisugata('')
        setKikakuCode('')
        setKikaku('')
        setKgKubun(1)
        setKgSuryo('')
        setSuryo(1)
        setYokiCode('')
        setYoki('')
        setCommentCode('')
        setComment('')
        setMemoCode('')
        setMemo('')
        setSenbetsuFlag(0)
        setMikomiFlag(0)
        setSeqNo(1)
        setBidStatus(0)
        senmeiRef.current.focus()
        setFocusCell('senmei')
    }
	//-----------------------------------------------
    // eventHandler - グループ登録ボタン
	//-----------------------------------------------
    const handleClick_groupNo_register = () => {
        const requireStatus = checkedGroup() // 必須項目をチェックする
        if (requireStatus) {
            getNextNo()
        } else {
            handleClickSnackBarRequire()
        }
    }
	//-----------------------------------------------
    // eventHandler - グループ解除ボタン
	//-----------------------------------------------
    const handleClick_groupNo_delete = () => {
        checkedUnloadList.map(async (checkedUnloadListId) => {
            unloadList.map(item => {
                let bidData = {}
                if (item.id == checkedUnloadListId) { 
                    bidData = item
                    setGroupNo(bidData.entryId, '', 1)
                }
            })
        })
    }
	//-----------------------------------------------
    // eventHandler - 船名グループヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_shipGroup = () => {
        setOpenDialogShipGroup(true)
    }
	//-----------------------------------------------
    // eventHandler - 船名グループヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_shipGroup_close = () => {
        setOpenDialogShipGroup(false)
    }
	//-----------------------------------------------
    // eventHandler - 船名ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_ship = () => {
        setOpenDialogShip(true)
    }
	//-----------------------------------------------
    // eventHandler - 船名ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_ship_close = () => {
        setOpenDialogShip(false)
    }
	//-----------------------------------------------
    // eventHandler - 魚種ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_fishSpec = () => {
        setOpenDialogFishSpec(true)
    }
	//-----------------------------------------------
    // eventHandler - 魚種ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_fishSpec_close = () => {
        setOpenDialogFishSpec(false)
    }
	//-----------------------------------------------
    // eventHandler - 容器ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_container = () => {
        setOpenDialogContainer(true)
    }
	//-----------------------------------------------
    // eventHandler - 容器ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_container_close = () => {
        setOpenDialogContainer(false)
    }
	//-----------------------------------------------
    // eventHandler - 規格ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_standard = () => {
        setOpenDialogStandard(true)
    }
	//-----------------------------------------------
    // eventHandler - 規格ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_standard_close = () => {
        setOpenDialogStandard(false)
        kgSuryoRef.current.focus()
    }
	//-----------------------------------------------
    // eventHandler - 荷姿ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_fishStyle = () => {
        setOpenDialogFishStyle(true)
    }
	//-----------------------------------------------
    // eventHandler - 規格ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_fishStyle_close = () => {
        setOpenDialogFishStyle(false)
        kgSuryoRef.current.focus()
    }
	//-----------------------------------------------
    // eventHandler - 登録ボタン
	//-----------------------------------------------
    const handleClick_Register = async (activeFlag) => {
        
        // 新規の場合はentryIdを発行して登録処理を実行
        if (!entryId) {
            await getNextId()
        
        // 更新の場合は既存のentryIdに対して登録処理を実行
        } else {
            const requireStatus = checkedRequire() // 必須項目をチェックする
            if (requireStatus) {
                await setData(entryId, activeFlag)
            } else {
                handleClickSnackBarRequire()
            }
        }
    }
	//-----------------------------------------------
    // eventHandler - 荷姿の変更
	//-----------------------------------------------
    const handleChange_nisugata = (value) => {
        setNisugata(value)
    }
	//-----------------------------------------------
    // eventHandler - 数量の変更
	//-----------------------------------------------
    const handleChange_suryo = (value) => {
        setSuryo(value)
    }
	//-----------------------------------------------
    // eventHandler - Kg区分の変更
	//-----------------------------------------------
    const handleChange_kgKubun = (value) => {
        setKgKubun(value)
    }
	//-----------------------------------------------
    // eventHandler - コメントの変更
	//-----------------------------------------------
    const handleChange_comment = (value) => {
        getData_comment(value)
    }
	//-----------------------------------------------
    // eventHandler - メモの変更
	//-----------------------------------------------
    const handleChange_memo = (value) => {
        getData_memo(value)
    }
    const handleChange_senbetsuFlag = (checked) => {
        setSenbetsuFlag(checked)
    }
    const handleChange_mikomiFlag = (checked) => {
        setMikomiFlag(checked)
    }
    const handleClick_update_displayNo = () => {
        
        unloadList.map((row, index) => {
            updateDisplayNo(row.entryId, (index + 1))
        })
    }
	//-----------------------------------------------
    // eventHandler - テンキーを操作
	//-----------------------------------------------
    const handleClick_numpad = (item) => {
        let prevVal
        let targetVal

        // ここで focusCell の値によって prevVal を設定する
        if (focusCell == 'senmei') {
            if (senmeiCode) {
                prevVal = ''
                setSenmeiCode('')
            } else {
                prevVal = senmei
            }
        } else if (focusCell == 'gyoshu') {
            if (gyoshuCode) {
                prevVal = ''
                setGyoshuCode('')
            } else {
                prevVal = gyoshu
            }
        } else if (focusCell == 'kikaku') {
            prevVal = kikaku
        } else if (focusCell == 'kgSuryo') {
            prevVal = kgSuryo
        } else if (focusCell == 'yoki') {
            if (yokiCode) {
                prevVal = ''
                setYokiCode('')
            } else {
                prevVal = yoki
            }
        } else if (focusCell == 'suryo') {
            prevVal = suryo
        } else {
        }
        if (item == 'C') {
            if (focusCell == 'senmei') { setSenmeiCode('')
            } else if (focusCell == 'gyoshu') { setGyoshuCode('')
            } else if (focusCell == 'yoki') { setYokiCode('')
            } else if (focusCell == 'suryo') { setSuryo(1)
            } else {}
            targetVal = ''
        } else {
            targetVal = `${prevVal}${item}` 
        }

        // ここで focusCell の値によって異なる state 更新関数を呼び出す
        if (focusCell == 'senmei') {
            setSenmei(targetVal)
        } else if (focusCell == 'gyoshu') {
            setGyoshu(targetVal)
        } else if (focusCell == 'kikaku') {
            setKikaku(targetVal)
        } else if (focusCell == 'kgSuryo') {
            setKgSuryo(targetVal)
        } else if (focusCell == 'yoki') {
            setYoki(targetVal)
        } else if (focusCell == 'suryo') {
            setSuryo(targetVal)
        } else {}
    }
	//-----------------------------------------------
    // eventHandler - テンキーで「ENT」をクリック
	//-----------------------------------------------
    const handleClick_numpad_enter = () => {
        if (focusCell == 'senmei') {
            setSenmeiCode('')
            setSenmei('')
            getData_ship()
            gyoshuRef.current.focus()
            setFocusCell('gyoshu')
        } else if (focusCell == 'gyoshu') {
            setGyoshuCode('')
            setGyoshu('')
            getData_fishSpec()
            kikakuRef.current.focus()
            setFocusCell('kikaku')
        } else if (focusCell == 'kikaku') {
            setKikakuCode('')
            setKikaku('')
            getData_standard()
            kgSuryoRef.current.focus()
            setFocusCell('kgSuryo')
        } else if (focusCell == 'kgSuryo') {
            // 数字か小数点以外の文字を削除し、小数点1桁までに正規化
            const targetNumber = String(kgSuryo)
            let normalizedValue = targetNumber.replace(/[^0-9.]/g, ''); // 数字と小数点以外を削除

            // カンマを削除
            normalizedValue = normalizedValue.replace(/,/g, '');

            // ピリオドが最初にある場合、前に0を追加
            if (normalizedValue.indexOf('.') === 0) {
                normalizedValue = '0' + normalizedValue;
            }
            // ピリオドが最後にある場合、後ろに0を追加
            if (normalizedValue.lastIndexOf('.') === normalizedValue.length - 1) {
                normalizedValue = normalizedValue + '0';
            }
            // 2つ以上のピリオドがある場合、最初のピリオド以外を削除
            const parts = normalizedValue.split('.');
            // 整数部が空の場合、0を追加
            if (!parts[1]) {
                normalizedValue= normalizedValue + '.0'
            }
            if (parts.length > 2) {
                normalizedValue = parts[0] + '.' + parts[1];
            }
            // 整数部が0の場合、0を追加
            if (parts.length === 1 && parts[0] === '') {
                normalizedValue = '0';
            }
            // 小数部が1桁以上の場合、最後の桁を削除して1桁にする
            if (parts.length === 2 && parts[1].length > 1) {
                parts[1] = parts[1].slice(0, 1);
                normalizedValue = parts.join('.');
            }
            setKgSuryo(normalizedValue);

            yokiRef.current.focus()
            setFocusCell('yoki')
            handleClick_dialog_container()
        } else if (focusCell == 'yoki') {
            setYokiCode('')
            setYoki('')
            getData_container()
            senmeiRef.current.focus()
            setFocusCell('senmei')
        } else if (focusCell == 'suryo') {
            senmeiRef.current.focus()
            setFocusCell('suryo')
        } else {}
    }
	//-----------------------------------------------
    // eventHandler - テンキーで「規格」をクリック
	//-----------------------------------------------
    const handleClick_numpad_kikaku = (item) => {
        const prevVal = kikaku
        const targetVal = `${prevVal}${item}` // targetVal を計算する
        setKikaku(targetVal)
        kikakuRef.current.focus()
        setFocusCell('kikaku')
    }
	//===============================================
	// dataGrid
	//===============================================
	//-----------------------------------------------
    // dataGrid - 水揚一覧の見出し
	//-----------------------------------------------
    const columns = [
        { field: 'groupNo',    headerName: 'Gp',   width: 60, columnSeparatorWidth: 1, },
        { field: 'senmei', headerName: '荷主',    width: 100, columnSeparatorWidth: 1, },
        { field: 'displayGyoshu', headerName: '品名',    width: 180, columnSeparatorWidth: 1, },
        {
            field: 'kgKubun',
            headerName: '単位',
            width: 75,
            renderCell: (params) => (
              <div>
                {unitMapping[params.value] || params.value}
              </div>
            ),
        },
        { field: 'suryo', headerName: '数量',    width: 80, columnSeparatorWidth: 1, type:'number'},
        { field: 'yoki',    headerName: '容器',  width: 80, columnSeparatorWidth: 1, },
        { field: 'kgSuryo', headerName: 'Kg数',    width: 80, columnSeparatorWidth: 1, type:'number'},
    ]
    const unitMapping = {
        1: 'Kg',
        0: '箱',
    }
	//-----------------------------------------------
    // dataGrid - マスタヘルプの見出し
	//-----------------------------------------------
    const columns_help = [
        { field: 'code',        headerName: 'コード',   width: 150, columnSeparatorWidth: 1, },
        { field: 'name',        headerName: '名称',     width: 250, columnSeparatorWidth: 1, },
        { field: 'displayName', headerName: '表示名称', width: 250, columnSeparatorWidth: 1, },
    ]
    //-----------------------------------------------
    // dataGrid - 水揚一覧の行の選択
    //-----------------------------------------------
    const handleClick_dataGrid = (event) => {
        setTargetList(event.row)
    }
    //-----------------------------------------------
    // dataGrid - 船名グループマスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_shipGroup = (code, displayName) => {
        setSenmeiGroupCode(code)
        setSenmeiGroup(displayName)
        searchData_ship(code)
        handleClick_dialog_shipGroup_close()
    }
    //-----------------------------------------------
    // dataGrid - 船名マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_ship = (code, displayName) => {
        setSenmeiCode(code)
        setSenmei(displayName)
        handleClick_dialog_ship_close()
        handleClick_dialog_fishSpec()
    }
    //-----------------------------------------------
    // dataGrid - 魚種マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_fishSpec = (code, displayName) => {
        setGyoshuCode(code)
        setGyoshu(displayName)
        handleClick_dialog_fishSpec_close()
        handleClick_dialog_fishStyle()
    }
    //-----------------------------------------------
    // dataGrid - 荷姿マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_fishStyle = (code, displayName) => {
        setNisugata(code)
        handleClick_dialog_fishStyle_close()
        handleClick_dialog_standard()
    }
    //-----------------------------------------------
    // dataGrid - 規格マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_standard = (code, displayName) => {
        setKikakuCode(code)
        setKikaku(displayName)
        handleClick_dialog_standard_close()
        setFocusCell('kgSuryo')
        kgSuryoRef.current.focus()
    }
    //-----------------------------------------------
    // dataGrid - 容器マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_container = (code, displayName) => {
        setYokiCode(code)
        setYoki(displayName)
        handleClick_dialog_container_close()
    }
    //-----------------------------------------------
    // dataGrid - 表示順の制御
    //-----------------------------------------------
    const areRowsConsecutive = (selectedIndexes) => {
        for (let i = 1; i < selectedIndexes.length; i++) {
            if (selectedIndexes[i] - selectedIndexes[i - 1] !== 1) {
                return false;
            }
        }
        return true;
    }
    //-----------------------------------------------
    // dataGrid - 表示順の変更
    //-----------------------------------------------
    const moveRows = (direction) => {
        let newRows = [...unloadList];
        let selectedIndexes = checkedUnloadList.map(selectedId => 
            newRows.findIndex(row => row.id === selectedId)).sort((a, b) => a - b)
        
        if (!areRowsConsecutive(selectedIndexes)) {
            setRequireMessage('行の移動には連続した行をチェックしてください');
            handleClickSnackBarRequire()
            return;
        }
      
        if (areRowsConsecutive(selectedIndexes)) {
            if (direction === 'up' && selectedIndexes[0] > 0) {
                for (let i = 0; i < selectedIndexes.length; i++) {
                    const index = selectedIndexes[i];
                    [newRows[index], newRows[index - 1]] = [newRows[index - 1], newRows[index]];
                }
            } else if (direction === 'down' && selectedIndexes[selectedIndexes.length - 1] < newRows.length - 1) {
                for (let i = selectedIndexes.length - 1; i >= 0; i--) {
                    const index = selectedIndexes[i];
                    [newRows[index], newRows[index + 1]] = [newRows[index + 1], newRows[index]];
                }
            }
        }
        setUnloadList(newRows);
    }
	//===============================================
	// Function
	//===============================================
	//-----------------------------------------------
	// Function - 必須項目をチェックする
	//-----------------------------------------------
    const checkedRequire = () => {
        const errorFields = [];
    
        //if (!entryId) errorFields.push('「伝票番号」')
        if (!senmeiCode) errorFields.push('「荷主」')
        if (!gyoshuCode) errorFields.push('「品名」')
    
        if (errorFields.length) {
            const text = errorFields.join('、') + 'が入力されていません'
            setRequireMessage(text);
            return false;  // エラーがある場合は false を返します
        }
        
        return true  // エラーがない場合は true を返します
    }
	//-----------------------------------------------
	// Function - グループ化可能かチェックする
	//-----------------------------------------------
    const checkedGroup = () => {
        const errorFields = []

        // unloadListが1件以上ある場合のみ処理を行う
        const filteredUnloadList = unloadList.filter(item => checkedUnloadList.includes(item.id));
        if (filteredUnloadList.length > 1) {
            // unloadList内の最初の指定項目を取得
            const firstSenmei    = filteredUnloadList[0].senmei
            const firstGyoshu    = filteredUnloadList[0].gyoshu
            const firstKikaku    = filteredUnloadList[0].kikaku
            const firstNisugata = filteredUnloadList[0].nisugata

            // UnloadList内のすべての指定項目が一致しているかチェック
            const allSenmeiMatch    = filteredUnloadList.every(item => item.senmei === firstSenmei)
            const allGyoshuMatch    = filteredUnloadList.every(item => item.gyoshu === firstGyoshu)
            const allKikakuMatch    = filteredUnloadList.every(item => item.kikaku === firstKikaku)
            const allNisugataMatch = filteredUnloadList.every(item => item.nisugata === firstNisugata)

            if (!allSenmeiMatch) errorFields.push('「荷主」')
            if (!allGyoshuMatch) errorFields.push('「魚種」')
            if (!allKikakuMatch) errorFields.push('「規格」')
            if (!allNisugataMatch) errorFields.push('「荷姿」')
        }
    
        if (errorFields.length) {
            const text = errorFields.join('') + 'が同一のものを指定してください'
            setRequireMessage(text);
            return false;  // エラーがある場合は false を返します
        }
        
        return true  // エラーがない場合は true を返します
    }
	//===============================================
	// UI Message
	//===============================================
    // コンファームの表示
    const handleOpenConfirm = () => { setOpenConfirm(true) }
    
    // コンファームを閉じる
    const handleCloseConfirm = () => { setOpenConfirm(false) }
    
    // スナックバー(必須チェック)を表示
    const handleClickSnackBarRequire = () => { setOpenRequire(true) }
    
	// スナックバー(必須チェック)を閉じる
    const handleCloseSnackBarRequire = (event, reason) => {
        if (reason === 'clickaway') { return } setOpenRequire(false)
    }
	// スナックバー(正常)を表示
    const handleClickSnackBarTrue = () => { setOpenSnackBarTrue(true) }
    
	// スナックバー(正常)を閉じる
    const handleCloseSnackBarTrue = (event, reason) => {
        if (reason === 'clickaway') { return } setOpenSnackBarTrue(false)
    }
	// スナックバー(異常)を表示
    const handleClickSnackBarFalse = () => { setOpenSnackBarFalse(true) }
    
	// スナックバー(異常)を閉じる
    const handleCloseSnackBarFalse = (event, reason) => {
        if (reason === 'clickaway') { return } setOpenSnackBarFalse(false)
    }
    //===============================================
    // Css
    //===============================================
    const button_new = {
        fontSize: '18px', height:'68px', width:'80px', color:'#fff', backgroundColor:'#305496' 
    }
    const button_delete = { 
        fontSize: '18px', height:'70px', width:'80px', color:'#fff', backgroundColor:'#ff0000'
    }
    const dialog_button_close = { 
        fontSize: '16px', height:'40px', width:'690px', color:'#fff', backgroundColor:'#808080'
    }
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage="/home" />
            <div className='unloadList bodyContens'>
                <TitleBar title="水揚げ情報" />
                <div style={{ display: 'flex', height: containerHeight }} className='mainContents'>
                    <div style={{ flex: 1, padding: '0px' }}>
                        <Frame classname="frame" title="水揚げ情報検索">
                            <BidSearchForm
                                targetDateId       = "unloadList_targetDate"
                                targetDateValue    = { entryDate }
                                targetDateOnChange = { (e) => setEntryDate(e.target.value) }
                                keywordId          = "unloadList_condition"
                                keywordValue       = { condition }
                                keywordOnChange    = { (e) => setCondition(e.target.value) }
                                handleSearch       = { () => handleClick_search() }
                                handleSearchClear  = { () => handleClick_search_clear() }
                            />
                        </Frame>
                        <Frame classname="frame" title="水揚げ情報一覧">
                            <div style={{display:'flex'}}>
                                <div style={{marginBottom:'0px', marginLeft:'0px'}}>
                                    <Button
                                        color     = "secondary"
                                        style     = {{color:'#fff'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<UpdateIcon />}
                                        onClick   = {() => handleClick_update_displayNo() }
                                    >
                                    表示順更新
                                    </Button>
                                </div>
                                <div style={{marginLeft:'10px', marginBottom:'10px'}}>
                                    <Button
                                        color     = "primary"
                                        style     = {{color:'#fff',paddingLeft:'30px'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<ArrowCircleUpIcon />}
                                        onClick={ () => moveRows('up')}
                                    >
                                    </Button>
                                </div>
                                <div style={{marginLeft:'10px', marginBottom:'10px'}}>
                                    <Button
                                        color     = "primary"
                                        style     = {{color:'#fff',paddingLeft:'30px'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<ArrowCircleDownIcon />}
                                        onClick={ () => moveRows('down')}
                                    >
                                    </Button>
                                </div>
                                <div style={{marginLeft:'20px', marginBottom:'10px'}}>
                                    <Button
                                        color     = "secondary"
                                        style     = {{color:'#fff'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<CheckBoxIcon />}
                                        onClick={ () => handleClick_groupNo_register()}
                                    >{"グループ登録"}
                                    </Button>
                                </div>
                                <div style={{marginLeft:'10px', marginBottom:'10px'}}>
                                    <Button
                                        color     = "secondary"
                                        style     = {{color:'#fff'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<CheckBoxOutlineBlankIcon />}
                                        onClick={ () => handleClick_groupNo_delete()}
                                    >{"グループ解除"}
                                    </Button>
                                </div>
                            </div>
                            <div style={{ flexGrow: 1, width: dataGridWidth}}>
                                <CustomDataGrid
                                    getRowClassName={(params) =>
                                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                    }
                                    editMode                = "row"
                                    rows                    = { unloadList }
                                    columns                 = { columns }
                                    sx                      = { {height:dataGridHeight,fontSize:14,borderColor: 'primary.light',} }
                                    density                 = "compact"
                                    localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                                    showColumnRightBorder
                                    showCellRightBorder
                                    checkboxSelection
                                    disableRowSelectionOnClick = {false}
                                    disableColumnMenu          = {true}
                                    loading                 = { searchData_Loading }
                                    onCellClick             = {(event) => handleClick_dataGrid(event)}
                                    onRowSelectionModelChange  = {(newSelectionModel) => { setCheckedUnloadList(newSelectionModel) }}
                                    rowSelectionModel          = {checkedUnloadList}
                                />
                            </div>
                        </Frame>
                    </div>
                    <div style={{ width: '410px', padding: '0px'}}>
                            <div style={{backgroundColor:'#efefef', padding:'10px', height : contentsHeight}}>
                                <div style={{ marginRight : '10px', display : 'flex', }}>
                                    <BidMastaInputForm
                                        mastaName        = '荷主'
                                        inputRef         = { senmeiRef }
                                        inputId          = 'unloadList_senmei'
                                        handleClick      = {() => handleClick_dialog_shipGroup()}
                                        nameValue        = { senmei }
                                        handleChangeName = {(e) => setSenmei(e.target.value)}
                                        handleClickName  = {() => handleClick_senmei()}
                                    />
                                </div>
                                <div style={ {marginRight : '10px', display : 'flex', marginTop : '10px'} }>
                                    <div style={{marginLeft:'0px'}}>
                                        <Button color="primary" size="large" variant="contained"
                                            sx={{ fontSize: '14px', height:'38px', width:'80px' }}
                                            onClick      = {() => handleClick_dialog_fishSpec()}
                                            >品名
                                        </Button>
                                    </div>
                                    <div style={{marginLeft:'4px'}}>
                                        <ReaOnlyOutlinedInput
                                            type     = "text"
                                            id       = "unloadList_gyoshu"
                                            inputRef = { gyoshuRef }
                                            label    = "品名"
                                            value    = { gyoshu }
                                            onClick  = {() => handleClick_gyoshu()}
                                            onChange = {(e) => setGyoshu(e.target.value)}
                                            width    = "215px"
                                        />
                                    </div>
                                    <div style={{marginLeft:'5px'}}>
                                        <CustomSelect
                                            id         = "userList_authority"
                                            label      = "荷姿"
                                            width      = "80px"
                                            dataList   = {fishStyleList} 
                                            selectedId = {nisugata}
                                            onChange   = {(e) => handleChange_nisugata(e.target.value)} 
                                        />
                                    </div>
                                </div>
                                <div style={{marginRight:'10px', display:'flex', marginTop:'10px'}}>
                                    <div style={{marginLeft:'0px'}}>
                                        <Button color="primary" size="large" variant="contained"
                                            sx={{ fontSize: '14px', height:'38px', width:'80px' }}
                                            onClick      = {() => handleClick_dialog_standard()}
                                            >規格
                                        </Button>
                                    </div>
                                    <div style={{marginLeft:'4px'}}>
                                        <ReaOnlyOutlinedInput
                                            type     = "text"
                                            id       = "unloadList_kikaku"
                                            inputRef = { kikakuRef }
                                            label    = "規格"
                                            value    = { kikaku }
                                            onClick  = {() => handleClick_kikaku()}
                                            onChange = {(e) => setKikaku(e.target.value)}
                                            width    = "130px"kgSuryoRef
                                        />
                                    </div>
                                    <div style={{marginLeft:'5px'}}>
                                        <ReaOnlyOutlinedInput
                                            type     = "text"
                                            id       = "unloadList_kgSuryo"
                                            inputRef = { kgSuryoRef }
                                            label    = "K数"
                                            value    = { kgSuryo }
                                            onClick  = {() => setFocusCell('kgSuryo')}
                                            onChange = {(e) => setKgSuryo(e.target.value)}
                                            width    = "80px"
                                        />
                                    </div>
                                    <div style={{marginLeft:'5px'}}>
                                        <CustomCheckbox
                                            defaultChecked = { mikomiFlag }
                                            width      = "100px"
                                            onChange       = { (e) => handleChange_mikomiFlag(e.target.checked) }
                                            label          = "見込み"
                                        />
                                    </div>
                                </div>
                                <div style={ {marginRight : '10px', display : 'flex', marginTop : '10px'} }>
                                    <div style={{marginLeft:'0px'}}>
                                        <Button color="primary" size="large" variant="contained"
                                            sx={{ fontSize: '14px', height:'38px', width:'80px' }}
                                            onClick      = {() => handleClick_dialog_container()}
                                            >容器
                                        </Button>
                                    </div>
                                    <div style={{marginLeft:'4px'}}>
                                        <ReaOnlyOutlinedInput
                                            type     = "text"
                                            id       = "unloadList_yoki"
                                            inputRef = { yokiRef }
                                            label    = "容器"
                                            value    = { yoki }
                                            onClick  = {() => handleClick_yoki()}
                                            onChange = {(e) => setYoki(e.target.value)}
                                            width    = "130px"
                                        />
                                    </div>
                                    <div style={{marginLeft:'5px'}}>
                                        <CustomSelect
                                            id         = "userList_authority"
                                            label      = "Kg区分"
                                            width      = "80px"
                                            dataList   = {kgDivision} 
                                            selectedId = {kgKubun}
                                            onChange   = {(e) => handleChange_kgKubun(e.target.value)} 
                                        />
                                    </div>
                                    <div style={{marginLeft:'5px'}}>
                                        <ReaOnlyOutlinedInput
                                            type     = "text"
                                            id         = "unloadList_suryo"
                                            inputRef = { suryoRef }
                                            label      = "数量"
                                            width      = "80px"
                                            value    = { suryo }
                                            onClick  = {() => setFocusCell('suryo')}
                                            onChange   = {(e) => handleChange_suryo(e.target.value)} 
                                        />
                                    </div>
                                </div>
                                <div style={ {marginRight : '10px', display : 'flex', marginTop : '10px'} }>
                                    <div style={{marginLeft:'5px'}}>
                                        <CustomCheckbox
                                            defaultChecked = { senbetsuFlag }
                                            onChange       = { (e) => handleChange_senbetsuFlag(e.target.checked) }
                                            label          = "選別"
                                        />
                                    </div>
                                    <div style={{marginLeft:'0px'}}>
                                        <CustomSelect
                                            id         = "unloadList_comment"
                                            label      = "コメント"
                                            width      = "130px"
                                            dataList   = {commentList} 
                                            selectedId = {commentCode}
                                            onChange   = {(e) => handleChange_comment(e.target.value)} 
                                        />
                                    </div>
                                    <div style={{marginLeft:'5px'}}>
                                        <CustomSelect
                                            id         = "unloadList_memo"
                                            label      = "メモ"
                                            width      = "160px"
                                            dataList   = {memoList} 
                                            selectedId = {memoCode}
                                            onChange   = {(e) => handleChange_memo(e.target.value)} 
                                        />
                                    </div>
                                </div>
                                <div style={{display:'flex'}}>
                                    <div>
                                        <div style={{marginTop:'5px'}}>
                                            <Button
                                                color   = "secondary"
                                                size    = "large"
                                                variant = "contained"
                                                style   = {{ fontSize: '18px', height:'53px', width:'80px', color:'#fff'}}
                                                onClick = {() => handleClick_numpad_kikaku('/')}
                                                >
                                                {'/'}
                                            </Button>
                                        </div>
                                        <div style={{marginTop:'5px'}}>
                                            <Button
                                                color   = "secondary"
                                                size    = "large"
                                                variant = "contained"
                                                style   = {{ fontSize: '18px', height:'53px', width:'80px', color:'#fff'}}
                                                onClick = {() => handleClick_numpad_kikaku('K')}
                                                >
                                                {'K'}
                                            </Button>
                                        </div>
                                        <div style={{marginTop:'5px'}}>
                                            <Button
                                                color   = "secondary"
                                                size    = "large"
                                                variant = "contained"
                                                style   = {{ fontSize: '18px', height:'53px', width:'80px', color:'#fff'}}
                                                onClick = {() => handleClick_numpad_kikaku('以下')}
                                                >
                                                {'以下'}
                                            </Button>
                                        </div>
                                        <div style={{marginTop:'5px'}}>
                                            <Button
                                                color   = "secondary"
                                                size    = "large"
                                                variant = "contained"
                                                style   = {{ fontSize: '18px', height:'53px', width:'80px', color:'#fff'}}
                                                onClick = {() => handleClick_numpad_kikaku('キズ')}
                                                >
                                                {'キズ'}
                                            </Button>
                                        </div>
                                        <div style={{marginTop:'8px'}}>
                                            <Button
                                                color   = "primary"
                                                size    = "large"
                                                variant = "contained"
                                                sx      = { button_new }
                                                onClick = { () => handleClick_new() }
                                            >{'新規'}
                                            </Button>
                                        </div>
                                    </div>
                                    <div style={{ width:'290px', paddingTop:'5px', marginLeft:'10px'}}>
                                    <NumPad onKeyPress = { (e) => handleClick_numpad(e) } array={['7', '8', '9', '4', '5', '6', '1', '2', '3', '0', '.', 'C']} />
                                    </div>
                                </div>
                                <div style={{display:'flex'}}>
                                    <div style={{display:'flex'}}>
                                        <div style={{marginTop:'5px'}}>
                                            <Button
                                                color   = "attention"
                                                size    = "large"
                                                variant = "contained"
                                                sx      = { button_delete }
                                                onClick = { () => handleOpenConfirm() }
                                            >{'削除'}
                                            </Button>
                                        </div>
                                        <div style={{marginLeft:'10px', marginTop:'5px'}}>
                                            <Button
                                                color   = "secondary"
                                                size    = "large"
                                                variant = "contained"
                                                style   = {{ fontSize: '22px', height:'70px', width:'93px', color:'#fff', backgroundColor:'#808080' }}
                                                onClick = {() => handleClick_numpad_enter()}
                                                >
                                                {'ENT'}
                                            </Button>
                                        </div>
                                        <div style={{marginLeft:'5px', marginTop:'5px'}}>
                                            <Button
                                                color   = "secondary"
                                                size    = "large"
                                                variant = "contained"
                                                style   = {{ fontSize: '22px', height:'70px', width:'195px', color:'#fff', backgroundColor:'#4A9DBC' }}
                                                onClick = {() => handleClick_Register('1')}
                                                >
                                                {'登録'}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
                <div className='dialog_shipGroupList'>
                    <Dialog open={ openDialogShipGroup } onClose={ handleClick_dialog_shipGroup_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="荷主グループを選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'990px', height:'650px'}}>
                            {shipGroupList.map(item => (
                                <Button
                                    color   = "fifthly"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'210px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_shipGroup(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'90%', marginRight:'5%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_shipGroup_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_shipList'>
                    <Dialog open={ openDialogShip } onClose={ handleClick_dialog_ship_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="荷主を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'990px', height:'650px'}}>
                            {shipList.map((item, index) => (
                                <Button
                                    color   = {index === 0 ? "fifthly" : "secondary"}
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'210px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_ship(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'90%', marginRight:'5%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_ship_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_fishSpecList'>
                    <Dialog open={ openDialogFishSpec } onClose={ handleClick_dialog_fishSpec_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="魚種を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {fishSpecList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_fishSpec(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'90%', marginRight:'5%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_fishSpec_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_fishStyleList'>
                    <Dialog open={ openDialogFishStyle } onClose={ handleClick_dialog_fishStyle_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="荷姿を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {fishStyleList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_fishStyle(item.id, item.name)}
                                >{item.name}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'90%', marginRight:'5%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_fishStyle_close()}
                                startIcon = {<CloseIcon />}setKgKubun
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_yokiList'>
                    <Dialog open={ openDialogContainer } onClose={ handleClick_dialog_container_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="容器を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {containerList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_container(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'90%', marginRight:'5%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_container_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_kikakuList'>
                    <Dialog open={ openDialogStandard } onClose={ handleClick_dialog_standard_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="規格マスタ検索" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {standardList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_standard(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'90%', marginRight:'5%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_standard_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <CustomSnackBar
                    open            = {openSnackBarTrue}
                    onClose         = {() => handleCloseSnackBarTrue()}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "登録しました"
                />
                <CustomSnackBar
                    open            = {openSnackBarFalse}
                    onClose         = {() => handleCloseSnackBarFalse()}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = "登録に失敗しました"
                />
                <CustomSnackBar
                    open            = {openRequire}
                    onClose         = {() => handleCloseSnackBarRequire()}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = {requireMessage}
                />
                <CustomConfirm
                    open      = {openConfirm}
                    onClose   = {() => handleCloseConfirm()}
                    onClickNG = {() => handleCloseConfirm()}
                    onClickOK = {() => handleClick_Register(0)}
                    message   = "指定データの削除を行います。よろしいですか？"
                />
            </div>
        </>
    )
}
export default UnloadList

  